module.exports = __webpack_public_path__ + "static/media/2025_Danish_Industry.a4fa6429.png";